/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars */

type Combine<T> = T extends infer O ? { [K in keyof O]: O[K] } : never;

type UnionOmit<T, K extends number | string | symbol> = T extends unknown
  ? Omit<T, K>
  : never;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : 'never';

export const mergeDiscriminatedUnion = <T, K extends keyof T>(
  object: T,
  _key: K,
): Combine<UnionToIntersection<UnionOmit<T, K>>> => {
  return object as Combine<UnionToIntersection<UnionOmit<T, K>>>;
};
